import ProgressBar from '@luminopia/react-toolbox/lib/progress_bar'
import * as React from 'react'
import {connect, Dispatch} from 'react-redux'
import {RouteComponentProps} from 'react-router'

import {IPrescriptionData} from 'core/api/patient'
import {PrescriptionHistory} from 'core/components/prescription/prescription-history'
import Card from 'study_coordinator/components/Card'
import {IFormFields, prescriptionFormFactory} from 'study_coordinator/components/prescription'
import {
  getStudyCoordinatorRequest,
  getSubjectsRequest,
  IState,
  selectSubjectPrescriptions,
  updatePrescriptionRequest,
} from 'study_coordinator/store'

const formName = 'UpdatePrescriptionPagePrescriptionForm'
const PrescriptionForm = prescriptionFormFactory(formName)

export interface IRouteParams {
  subjectIdentifier: string
}

interface IStateProps {
  subjectIdentifier: string
  prescriptions?: IPrescriptionData[] | null
  isFetching: boolean
}

interface IDispatchProps {
  onSubmit: (data: IFormFields) => void
  onMount: () => void
}

interface IOwnProps extends RouteComponentProps<IRouteParams> {}

export interface IProps extends IStateProps, IDispatchProps, IOwnProps {}

export class CreatePrescriptionPage extends React.Component<IProps, {}> {
  public render() {
    const {subjectIdentifier, prescriptions} = this.props

    if (this.props.isFetching) {
      return <ProgressBar type='circular' mode='indeterminate' multicolor />
    }

    return (
      <div>
        <Card
          title='Update prescription'
          subtitle={`Subject ${subjectIdentifier}`}
          icon='assignment'
        >
          <PrescriptionForm
            subjectIdentifier={subjectIdentifier}
            onSubmit={this.props.onSubmit}
          />
        </Card>

        <Card title='Prescriptions' subtitle={`subject ${subjectIdentifier}`} icon='assignment'>
          <PrescriptionHistory prescriptions={prescriptions || []} />
        </Card>
      </div>
    )
  }

  public componentDidMount() {
    this.props.onMount()
  }
}

const mapStateToProps = (state: IState, ownProps: IOwnProps): IStateProps => {
  const subjectIdentifier = ownProps.match.params.subjectIdentifier
  const prescriptions = selectSubjectPrescriptions(state, ownProps.match.params.subjectIdentifier)
  const isFetching = state.subjects.isFetching || state.studyCoordinator.isFetching

  return {
    subjectIdentifier,
    prescriptions,
    isFetching,
  }
}

const mapDispatchToProps = (dispatch: Dispatch<void>, ownProps: IOwnProps): IDispatchProps => ({
  onSubmit: (data: IFormFields) => dispatch(updatePrescriptionRequest(data, formName)),
  onMount: () => {
    dispatch(getSubjectsRequest())
    dispatch(getStudyCoordinatorRequest())
  },
})

export default connect<IStateProps, IDispatchProps, IOwnProps, IState>(
  mapStateToProps,
  mapDispatchToProps,
)(CreatePrescriptionPage)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/pages/UpdatePrescriptionPage.tsx